import { generateRandomString } from "../crypto/crypto";

export const generateStateValue = (length = 16): string => {
  const value = generateRandomString(length);
  return value;
};
